import { hasAllLowestRubricRatings, isUnscoredRubric, usesCompleteIncompleteGrading } from 'utils/rubricScoring';

export const shouldPromptBeforeSubmissionNavigation = ({ hasChanges }) => Boolean(hasChanges);

export const requiresManualReviewBeforeBulkAccept = ({ assignment, selections }) =>
    Boolean(
        isUnscoredRubric(assignment) &&
            usesCompleteIncompleteGrading(assignment) &&
            hasAllLowestRubricRatings(assignment?.rubric?.criteria, selections)
    );
